import React from "react";
import { Redirect } from "react-router-dom";
import {
  PageSuspense,
  SignUpPage,
  VerificationCodePage,
  CreatePasswordPage,
  BusinessLinkCodePage,
} from "../lazyComponents";
import type { AppRoute } from "../types";

export const signupLegacyRedirectRoutes: AppRoute[] = [
  {
    path: "/signup/verify",
    main: () => (
      <PageSuspense>
        <VerificationCodePage />
      </PageSuspense>
    ),
  },
  {
    path: "/signup/create-password",
    main: () => (
      <PageSuspense>
        <CreatePasswordPage />
      </PageSuspense>
    ),
  },
  {
    path: "/signup/business-link",
    main: () => (
      <PageSuspense>
        <BusinessLinkCodePage />
      </PageSuspense>
    ),
  },
  {
    path: "/signup",
    main: () => (
      <PageSuspense>
        <SignUpPage />
      </PageSuspense>
    ),
  },
  {
    path: "/TaxManagementSignUp",
    main: () => <Redirect to="/signup" />,
  },
  {
    path: "/SignUpVerify",
    main: () => <Redirect to="/signup/verify" />,
  },
  {
    path: "/SignUpVerification",
    main: () => <Redirect to="/signup/create-password" />,
  },
  {
    path: "/SignUpReferalCode",
    main: () => <Redirect to="/signup/business-link" />,
  },
  {
    path: "/TaxManagementForgotPassword",
    main: () => <Redirect to="/forgot-password" />,
  },
  {
    path: "/EnterOtpForgotPassword",
    main: () => <Redirect to="/forgot-password/otp" />,
  },
  {
    path: "/ResetForgotPassword",
    main: () => <Redirect to="/forgot-password/reset" />,
  },
  {
    path: "/TaxManagementClientCases",
    main: () => <Redirect to="/cases" />,
  },
  {
    path: "/TaxManagementCaseDetails",
    main: () => <Redirect to="/cases" />,
  },
];
